/**
 * Preview counts come from a query capped at PREVIEW_RECIPIENT_LIMIT, so a capped count is a floor
 * rather than the audience size — the send goes to the real set. Every surface that shows a preview
 * count uses this so none of them can drift back to displaying a capped count as exact.
 */
export const formatRecipientCount = (count, capped) => (capped ? `${count}+` : String(count));
